export default __webpack_public_path__ + "static/media/mainlogo.663e4a9d.png";